<template>
  <div class="date-input is-relative">
    <details-data-field-label :label="name" :required="required" />

    <p class="control has-icons-right">
      <span v-if="disabled" class="text">{{ value }}</span>

      <input
        v-else
        class="input is-small"
        :class="classes"
        style="width: 200px"
        type="date"
        :placeholder="field"
        :disabled="!enabled"
        v-model="inputValue"
        data-id="detail-date-input"
        @keydown.enter="onBlur"
        @blur="onBlur"
      />

      <span class="icon is-small is-right has-text-danger" v-if="actionStatus.type === 'error'">
        <i class="fas fa-exclamation-triangle"></i>
      </span>
      <span class="icon is-small is-right has-text-success" v-if="actionStatus.type === 'success'">
        <i class="fas fa-check"></i>
      </span>
    </p>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator'
import { STATUS_OK } from '@/constants'

import DetailsDataComponentBase from './DetailsDataComponentBase.vue'

@Component({
  name: 'DetailsDateInput',
})
export default class DetailsDateInput extends DetailsDataComponentBase {
  @Prop({ default: true }) autoUpdate!: boolean

  protected inputValue = ''

  get numericValue() {
    return parseInt(this.inputValue, 10)
  }

  protected async onBlur() {
    if (!this.autoUpdate) {
      this.$emit('change', this.inputValue)
      return
    }

    const response = await this.submitAction({ [this.field]: this.inputValue })
    if (response.status === STATUS_OK) {
      this.$emit('change', this.inputValue)
    }
  }

  created() {
    this.inputValue = (this.value as string) || ''
  }
}
</script>

<style lang="scss" scoped>
.date-input {
  display: flex;
  justify-content: space-between;
  font-size: calc(10px + 0.2vh);

  .icon {
    display: block;
    padding-left: 5px;
  }

  .text {
    font-size: 0.73em;
    padding: 0.3em 0.6em;
    background-color: rgb(228, 228, 228);
    border-radius: 0.3em;
  }

  input {
    height: calc(18px + 0.2vh);
    font-size: 0.73em;
    width: 2.7em;
    padding: 0.3em;

    &:disabled {
      color: rgb(58, 58, 58);
    }

    &::placeholder {
      color: rgb(123, 123, 123);
    }
  }
}
</style>
